import { z } from "zod";

import { Media, Photo } from "@/components/forms/schemas/media";

export const eventNestedSchema = z.object({
  id: z.string().nullish(),
  name: z.string(),
  photo: Photo.nullish(),
  media: Media.nullish(),
});

export type EventNestedType = z.infer<typeof eventNestedSchema>;
